import { ArrowForward, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { ExchangeFormField } from "./ExchangeFormField";

export const ExchangeAssociations = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <ArrowForward style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Associations")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <ExchangeFormField label={t("ClientCode")} type="foreignKey" entity="Account" filterField={'AccountCode'} labelFields={['AccountCode']} extraFields={[{key: 'Id', value: 'ClientId'}, {key: 'AccountCode', value: 'ClientAccountCode'}]} code="ClientAccountCode" data={dataState} setData={setDataState} />
            <ExchangeFormField label={t("InvoiceCompany")} type="foreignKey" entity="Account" filterField={'AccountCode'} labelFields={['AccountCode']} extraFields={[{key: 'Id', value: 'InvoiceCompanyId'}, {key: 'AccountCode', value: 'InvoiceCompanyAccountCode'}]} code="InvoiceCompanyAccountCode" data={dataState} setData={setDataState} />
            <ExchangeFormField label={t("Currency")} type="foreignKey" entity="Currency" filterField={'Code'} labelFields={['Code']} extraFields={[{key: 'Id', value: 'CurrencyId'}, {key: 'Code', value: 'CurrencyCode'}]} code="CurrencyCode" data={dataState} setData={setDataState} />
            <ExchangeFormField label={t("Vessel")} type="foreignKey" entity="Vessel" filterField={'Code'} labelFields={['Code']} extraFields={[{key: 'Id', value: 'VesselId'}, {key: 'Code', value: 'VesselCode'}]} code="VesselCode" data={dataState} setData={setDataState} />
            <ExchangeFormField label={t("Voyage")} type="foreignKey" entity="Voyage" filterField={'VoyageNumber'} labelFields={['VoyageNumber']} extraFields={[{key: 'Id', value: 'VoyageId'}, {key: 'VoyageNumber', value: 'VoyageNumber'}]} code="VoyageNumber" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}